import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import "../style.css";
import { Translate } from "../../../../Enums/Tranlate";
import BaseService from "../../../../../services/BaseService";
import BranchesService from "../../../../../services/Company/BranchesService";
import AssetsService from "../../../../../services/Company/AssetsService";
import ScrollPagination from "../../../../common/ScrollPagination";
import EmployeesService from "../../../../../services/HRM/EmployeesService";
import DesignationsService from "../../../../../services/HRM/DesignationsService";
import { useLocation, useNavigate } from "react-router-dom";
import JobTypeService from "../../../../../services/HRM/JobTypeService";
import DepartmentService from "../../../../../services/Company/DepartmentService";
import WorkShiftService from "../../../../../services/Company/WorkShiftService";
const countryCodes = require("country-codes-list");

const AddEmployee = () => {
	const [formData, setFormData] = useState({
		name: "",
		type: "",
		civilId: "",
		civilIdExpiryDate: "",
		passportNo: "",
		passportExpiryDate: "",
		nationality: "",
		startDate: "",
		salary: "",
		iban: "",
		personalEmail: "",
		companyEmail: "",
		branchIds: [],
		mainBranchId: null,
		assetIds: [],
		attachments: [],
		gender: "",
		phone: "+965",
		password: "",
		designationId: "",
		departmentId: "",
	});
	const [showPassword, setShowPassword] = useState(true);
	const [nationalityOptions, setNationalityOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const genderTypes = [
		{ label: Translate[lang].male, value: "MALE" },
		{ label: Translate[lang].female, value: "FEMALE" },
	];
	const [isAdd, setIsAdd] = useState(true);
	const [loading, setLoading] = useState(false);
	const [jobTypesOptions, setJobTypesOptions] = useState([]);
	const [designationsOptions, setDesignationsOptions] = useState([]);
	const [departmentsOptions, setDepartmentsOptions] = useState([]);
	const [workShiftOptions, setWorkShiftOptions] = useState([]);
	const branchesService = new BranchesService();
	const assetsService = new AssetsService();
	const employeesService = new EmployeesService();
	const jobTypeService = new JobTypeService();
	const designationsService = new DesignationsService();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const myCountryCodesObject = countryCodes.customList(
			"countryCode",
			"{countryNameEn}/{countryNameLocal}",
		);
		const entries = Object.entries(myCountryCodesObject)?.map((c) => {
			return {
				label: c[1].split("/")[0],
				value: c[1]?.split("/")[0]?.toLocaleLowerCase(),
			};
		});
		setNationalityOptions([
			{ label: "non Kuwaiti", value: "non_kuwaiti" },
			...entries,
		]);
		jobTypeService.getList().then((res) => {
			if (res?.status) {
				const response = res?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setJobTypesOptions(response);
			}
		});
	}, []);

	useEffect(() => {
		if (!!formData?.branchIds?.length) {
			new DepartmentService()
				.getList({
					page: 1,
					limit: 1000,
					branchIds: formData?.branchIds?.map((res) => res?.value).join(","),
				})
				.then((res) => {
					if (res?.status) {
						const response = res?.data?.data?.data?.map((info) => {
							return {
								label: info?.name,
								value: info?.id,
							};
						});
						setDepartmentsOptions(response);
					}
				});
			designationsService
				.getList({
					page: 1,
					limit: 1000,
					branchIds: formData?.branchIds?.map((res) => res?.value).join(","),
				})
				.then((res) => {
					if (res?.status) {
						const response = res?.data?.data?.data?.map((info) => {
							return {
								label: info?.title,
								value: info?.id,
							};
						});
						setDesignationsOptions(response);
					}
				});
			new WorkShiftService()
				.getList({
					page: 1,
					limit: 1000,
					branchIds: formData?.branchIds?.map((res) => res?.value).join(","),
				})
				.then((res) => {
					if (res?.status) {
						const response = res?.data?.data?.data?.map((info) => {
							return {
								label: info?.name,
								value: info?.id,
							};
						});
						setWorkShiftOptions(response);
					}
				});
		}
	}, [formData?.branchIds]);

	useEffect(() => {
		if (!!nationalityOptions?.length) {
			if (location?.pathname?.includes("/edit-employee")) {
				setIsAdd(false);
				let id = location?.pathname?.slice(24);
				employeesService.find(id).then((res) => {
					const response = res?.data?.data;
					setFormData((prev) => ({
						...prev,
						id: response?.id,
						name: response?.name,
						gender: genderTypes.find((ty) => ty?.value === response?.gender),
						phone: response?.phoneNumber,
						type: {
							label: response?.employmentType?.name,
							value: response?.employmentType?.id,
						},
						nationality: nationalityOptions.find(
							(ty) => ty?.value === response?.nationality,
						),
						civilId: response?.civilId,
						civilIdExpiryDate: response?.civilIdExpiryDate.split("T")[0] || "",
						passportNo: response?.passportNo,
						passportExpiryDate:
							response?.passportExpiryDate.split("T")[0] || "",
						startDate: response?.startDate.split("T")[0] || "",
						salary: response?.salary,
						iban: response?.iban,
						companyEmail: response?.companyEmail,
						personalEmail: response?.personalEmail,
						assetIds: response?.assets?.map((ass) => ({
							label: ass?.name,
							value: ass?.id,
						})),
						branchIds: response?.branches?.map((info) => ({
							...info,
							label: info?.names[lang || "en"] || info?.name,
							value: info?.id,
							workShift: {
								...info?.workShift,
								label: info?.workShift?.name,
								value: info?.workShift?.id,
							},
						})),
						mainBranchId: response?.mainBranch
							? {
									label:
										response?.mainBranch?.names?.[lang || "en"] ||
										response?.mainBranch?.name,
									value: response?.mainBranch?.id,
							  }
							: response?.mainBranchId
							? {
									label:
										response?.branches?.find(
											(b) => b?.id === response?.mainBranchId,
										)?.names?.[lang || "en"] ||
										response?.branches?.find(
											(b) => b?.id === response?.mainBranchId,
										)?.name ||
										response?.mainBranchId,
									value: response?.mainBranchId,
							  }
							: response?.branches?.length === 1
							? {
									label:
										response?.branches[0]?.names?.[lang || "en"] ||
										response?.branches[0]?.name,
									value: response?.branches[0]?.id,
							  }
							: null,
						designationId: {
							label: response?.designation?.title,
							value: response?.designation?.id,
						},
						departmentId: {
							label: response?.department?.name,
							value: response?.department?.id,
						},
					}));
				});
			} else {
				setIsAdd(true);
			}
		}
	}, [nationalityOptions]);

	const handleBranchChange = (selectedBranches) => {
		const branches = selectedBranches || [];
		setFormData((prev) => {
			let newMainBranch = prev?.mainBranchId;

			if (branches.length === 1) {
				const b = branches[0];
				newMainBranch = {
					label: b?.label || b?.names?.[lang] || b?.name,
					value: b?.value || b?.id,
				};
			} else if (branches.length > 1) {
				if (prev?.branchIds?.length === 1) {
					newMainBranch = null;
				} else if (
					!branches.some(
						(b) => (b?.value || b?.id) === newMainBranch?.value,
					)
				) {
					newMainBranch = null;
				}
			} else {
				newMainBranch = null;
			}

			return {
				...prev,
				branchIds: branches,
				mainBranchId: newMainBranch,
			};
		});
	};

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.branchIds?.length) {
			toast.error(lang === "ar" ? "يرجى اختيار الفرع" : "Select branch");
			return;
		}
		if (!formData?.mainBranchId?.value) {
			toast.error(
				Translate[lang]?.main_branch_required ||
					(lang === "ar"
						? "يرجى اختيار الفرع الرئيسي"
						: "Please select main branch"),
			);
			return;
		}
		if (formData?.branchIds?.some((res) => !res?.workShift)) {
			toast.error(lang === "ar" ? "يرجى اختيار الوردية" : "Select WorkShift");
			return;
		}
		let data = {
			name: formData?.name,
			employmentTypeId: formData?.type?.value,
			civilId: formData.civilId,
			civilIdExpiryDate: formData.civilIdExpiryDate,
			passportNo: formData.passportNo,
			passportExpiryDate: formData.passportExpiryDate,
			nationality: formData?.nationality?.value,
			startDate: formData.startDate,
			salary: formData.salary,
			iban: formData.iban,
			personalEmail: formData.personalEmail,
			companyEmail: formData.companyEmail,
			mainBranchId: formData?.mainBranchId?.value,
			branches: formData?.branchIds?.map((res) => {
				return {
					branchId: res?.value,
					workShiftId: res?.workShift?.value,
				};
			}),
			assetIds: formData?.assetIds?.map((res) => res?.value),
			gender: formData?.gender?.value,
			phoneNumber: formData?.phone,
			departmentId: formData?.departmentId?.value,
			designationId: formData?.designationId?.value,
		};
		if (!!formData?.passwordTrans) {
			data["password"] = formData?.passwordTrans;
		}
		if (!!formData?.attachments?.length) {
			data["attachments"] = formData.attachments
				?.filter((attachment) => !!attachment)
				?.map((attachment) => {
					return {
						url: attachment,
					};
				});
		}

		setLoading(true);
		if (isAdd) {
			employeesService.create(data)?.then((res) => {
				if (res && res?.status === 201) {
					toast.success(`ِEmployee Added Successfully`);
					navigate("/employee");
				}
				setLoading(false);
			});
		} else {
			employeesService
				.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`ِEmployee Updated Successfully`);
						navigate("/employee");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e) => {
		let files = e.target.files;
		const filesData = Object.values(files);
		if (!!filesData?.length) {
			setLoading(true);
			new BaseService()
				.postUpload(filesData[0])
				.then((res) => {
					// if (res?.status === 201) {
					// 	setFormData({
					// 		...formData,
					// 		[name]: res?.data?.data?.uploadedFiles[0]?.url || "",
					// 	});
					// }
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Card className="px-3 py-4">
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Row>
					<Col md={12} className="mb-4">
						<div className="d-flex gap-12 align-items-center">
							<i
								className="fa fa-arrow-left cursor-pointer"
								onClick={() => navigate("/employee")}
							/>
							<p className="mb-0 fs-22 text-black fw-500">
								{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
								{Translate[lang]?.employee}
							</p>
						</div>
					</Col>
				</Row>
				<Row>
					<Col md={6} className="mb-3">
						<div
							className="px-3 py-4 h-100"
							style={{
								borderRadius: "11px",
								boxShadow: "0 0 4px #dedede7d",
							}}>
							{/* Name */}
							<div>
								<AvField
									label={Translate[lang]?.name}
									type="text"
									placeholder={Translate[lang]?.name}
									bsSize="lg"
									name="name"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.name}
									onChange={(e) =>
										setFormData({ ...formData, name: e.target.value })
									}
								/>
							</div>
							{/* Gender */}
							<div className="mb-3">
								<label className="text-label">{Translate[lang]?.gender}</label>
								<Select
									value={formData?.gender}
									name="gender"
									placeholder={Translate[lang]?.select}
									options={genderTypes}
									onChange={(e) => setFormData({ ...formData, gender: e })}
								/>
							</div>
							{/* Phone */}
							<div>
								<AvField
									label={Translate[lang]?.phone}
									type="text"
									placeholder={Translate[lang]?.phone}
									bsSize="lg"
									name="phone"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.phone}
									onChange={(e) =>
										setFormData({ ...formData, phone: e.target.value })
									}
								/>
							</div>
							{/* Type */}
							<div>
								<label className="text-label">{Translate[lang]?.type}</label>
								<Select
									value={formData?.type}
									name="type"
									placeholder={Translate[lang]?.select}
									options={jobTypesOptions}
									onChange={(e) => setFormData({ ...formData, type: e })}
								/>
							</div>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div
							className="px-3 pt-4 pb-1 h-100"
							style={{
								borderRadius: "11px",
								boxShadow: "0 0 4px #dedede7d",
							}}>
							{/* civil_id */}
							<div>
								<AvField
									label={Translate[lang]?.civil_id}
									type="text"
									placeholder={Translate[lang]?.civil_id}
									bsSize="lg"
									name="civil_id"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.civilId}
									onChange={(e) =>
										setFormData({ ...formData, civilId: e.target.value })
									}
								/>
							</div>
							{/* civilIdExpiryDate */}
							<div>
								<AvField
									label={Translate[lang]?.expiry_date}
									type="date"
									placeholder={Translate[lang]?.expiry_date}
									bsSize="lg"
									name="expiry_date"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.civilIdExpiryDate}
									onChange={(e) =>
										setFormData({
											...formData,
											civilIdExpiryDate: e.target.value,
										})
									}
								/>
							</div>
							{/* passportNo */}
							<div>
								<AvField
									label={Translate[lang]?.passport_number}
									type="text"
									placeholder={Translate[lang]?.passport_number}
									bsSize="lg"
									name="passportNo"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.passportNo}
									onChange={(e) =>
										setFormData({ ...formData, passportNo: e.target.value })
									}
								/>
							</div>
							{/* Passport Expiry Date */}
							<div>
								<AvField
									label={Translate[lang]?.passport_expiry_date}
									type="date"
									placeholder={Translate[lang]?.passport_expiry_date}
									bsSize="lg"
									name="passportExpiryDate"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.passportExpiryDate}
									onChange={(e) =>
										setFormData({
											...formData,
											passportExpiryDate: e.target.value,
										})
									}
								/>
							</div>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div
							className="px-3 pt-4 pb-1 h-100"
							style={{
								borderRadius: "11px",
								boxShadow: "0 0 4px #dedede7d",
							}}>
							{/* Nationality */}
							<div className="mb-3">
								<label className="text-label">
									{Translate[lang]?.nationality}
								</label>
								<Select
									value={formData?.nationality}
									name="country_code"
									placeholder={Translate[lang]?.select}
									options={nationalityOptions}
									onChange={(e) => setFormData({ ...formData, nationality: e })}
								/>
							</div>
							{/* start Date */}
							<div>
								<AvField
									label={Translate[lang]?.date_of_join}
									type="date"
									placeholder={Translate[lang]?.date_of_join}
									bsSize="lg"
									name="startDate"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.startDate}
									onChange={(e) =>
										setFormData({ ...formData, startDate: e.target.value })
									}
								/>
							</div>
							{/* salary */}
							<div>
								<AvField
									label={Translate[lang]?.salary}
									type="number"
									placeholder={Translate[lang]?.salary}
									bsSize="lg"
									name="salary"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.salary}
									onChange={(e) =>
										setFormData({ ...formData, salary: e.target.value })
									}
								/>
							</div>
							{/* iban */}
							<div>
								<AvField
									label={Translate[lang]?.iban}
									type="text"
									placeholder={Translate[lang]?.iban}
									bsSize="lg"
									name="iban"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.iban}
									onChange={(e) =>
										setFormData({ ...formData, iban: e.target.value })
									}
								/>
							</div>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div
							className="px-3 pt-4 pb-1 h-100"
							style={{
								borderRadius: "11px",
								boxShadow: "0 0 4px #dedede7d",
							}}>
							{/* Branch */}
							<div className="mb-3">
								<label className="text-label">
									{Translate[lang]?.branch} <span className="text-danger">*</span>
								</label>
								<ScrollPagination
									Service={branchesService}
									value={formData?.branchIds}
									nameVal="name"
									isMulti
									setData={handleBranchChange}
								/>
							</div>

							{/* Main Branch */}
							{!!formData?.branchIds?.length && (
								<div className="mb-3">
									<label className="text-label">
										{Translate[lang]?.main_branch || "Main Branch"}{" "}
										<span className="text-danger">*</span>
									</label>
									<Select
										value={formData?.mainBranchId}
										name="mainBranchId"
										placeholder={Translate[lang]?.select}
										options={formData?.branchIds?.map((branch) => ({
											label:
												branch?.label ||
												branch?.names?.[lang] ||
												branch?.name,
											value: branch?.value || branch?.id,
										}))}
										onChange={(e) =>
											setFormData((prev) => ({ ...prev, mainBranchId: e }))
										}
										isClearable={formData?.branchIds?.length > 1}
									/>
								</div>
							)}
							{!!formData?.branchIds &&
								formData?.branchIds?.map((branch, index) => {
									return (
										<div
											key={branch?.id}
											className="mb-3"
											style={{
												display: "grid",
												gap: "16px",
												gridTemplateColumns: "repeat(2, 1fr)",
											}}>
											<div>
												<label className="text-label">
													{Translate[lang]?.branch}
												</label>
												<Select
													value={branch}
													name={branch?.id}
													placeholder={Translate[lang]?.select}
													isDisabled
												/>
											</div>
											<div>
												<label className="text-label">
													{Translate[lang]?.work_shift}
												</label>
												<Select
													value={branch?.workShift}
													name={index}
													placeholder={Translate[lang]?.select}
													options={branch?.workShifts?.map((res) => ({
														label: res?.name,
														value: res?.id,
													}))}
													onChange={(e) =>
														setFormData((prev) => ({
															...prev,
															branchIds: prev?.branchIds?.map((res, ind) =>
																ind === index ? { ...res, workShift: e } : res,
															),
														}))
													}
												/>
											</div>
										</div>
									);
								})}

							{/* Designation */}
							<div className="mb-3">
								<label className="text-label">
									{Translate[lang]?.designation}
								</label>
								<Select
									value={formData?.designationId}
									name="designationId"
									placeholder={Translate[lang]?.select}
									options={designationsOptions}
									onChange={(e) =>
										setFormData({ ...formData, designationId: e })
									}
								/>
							</div>
							{/* Department */}
							<div className="mb-3">
								<label className="text-label">
									{Translate[lang]?.department}
								</label>
								<Select
									value={formData?.departmentId}
									name="departmentId"
									placeholder={Translate[lang]?.select}
									options={departmentsOptions}
									onChange={(e) =>
										setFormData({ ...formData, departmentId: e })
									}
								/>
							</div>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div
							className="px-3 pt-4 pb-1 h-100"
							style={{
								borderRadius: "11px",
								boxShadow: "0 0 4px #dedede7d",
							}}>
							{/* personal Email */}
							<div>
								<AvField
									label={Translate[lang]?.personal_email}
									type="email"
									placeholder={Translate[lang]?.email}
									bsSize="lg"
									name="personalEmail"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.personalEmail}
									onChange={(e) =>
										setFormData({ ...formData, personalEmail: e.target.value })
									}
								/>
							</div>
							{/* company Email */}
							<div>
								<AvField
									label={Translate[lang]?.company_email}
									type="text"
									placeholder={Translate[lang]?.email}
									bsSize="lg"
									autoComplete="off"
									name="companyEmail"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
										pattern: {
											value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
											errorMessage: "Enter a valid email",
										},
									}}
									value={formData.companyEmail}
									onChange={(e) =>
										setFormData({ ...formData, companyEmail: e.target.value })
									}
								/>
							</div>
							{/* Password */}
							<div className="form-group position-relative">
								<AvField
									label={Translate[lang]?.password}
									type={showPassword ? "text" : "password"}
									placeholder={Translate[lang]?.password}
									bsSize="lg"
									name="passwordTrans"
									autoComplete="off"
									onFocus={() => {
										setShowPassword(false);
									}}
									validate={{
										required: {
											value: isAdd,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.passwordTrans}
									onChange={(e) =>
										setFormData({ ...formData, passwordTrans: e.target.value })
									}
								/>
								{showPassword ? (
									<i
										className="la la-eye-slash position-absolute cursor-pointer"
										style={{
											top: "45px",
											right: lang === "en" ? "6%" : "auto",
											left: lang === "ar" ? "6%" : "auto",
										}}
										onClick={() => setShowPassword(false)}></i>
								) : (
									<i
										className="la la-eye position-absolute cursor-pointer"
										style={{
											top: "45px",
											right: lang === "en" ? "6%" : "auto",
											left: lang === "ar" ? "6%" : "auto",
										}}
										onClick={() => setShowPassword(true)}></i>
								)}
							</div>
							{/* Assets */}
							<div className="mb-3">
								<label className="text-label">{Translate[lang]?.assets}</label>
								<ScrollPagination
									Service={assetsService}
									value={formData?.assetIds}
									isMulti={true}
									nameVal="name"
									setData={(e) =>
										setFormData((prev) => ({ ...prev, assetIds: e }))
									}
								/>
							</div>
						</div>
					</Col>

					<Col md={12} className="mt-3">
						<label className="text-label mb-0">
							{Translate[lang]?.attachments}
						</label>
						<div className="upload">
							<input
								type="file"
								name="attachments"
								id="attachments"
								onChange={(e) => fileHandler(e)}
							/>
							<p>{Translate[lang].upload_files}</p>
							{!formData?.attachments?.length ? (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 15V3.62"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15.35 5.85L12 2.5L8.65002 5.85"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							) : (
								<svg
									width="24"
									height="24"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
										fill="#21AA37"
									/>
								</svg>
							)}
						</div>
					</Col>
					{!!formData.attachments?.length &&
						formData.attachments?.map((attachment, index) => {
							return (
								<Col md={3} key={index}>
									<div>
										<i
											className="la la-trash text-danger"
											onClick={() => {
												let update = formData.attachments?.filter(
													(_, ind) => index !== ind,
												);
												setFormData({ ...formData, attachments: update });
											}}></i>
										{attachment.includes("pdf") ? (
											<a href={attachment} target="_blank" rel="noreferrer">
												<i
													className="la la-file-pdf d-block"
													style={{ fontSize: "6rem" }}></i>
											</a>
										) : (
											<img src={attachment} alt={index} className="w-100" />
										)}
									</div>
								</Col>
							);
						})}
					<Col md={12}>
						<Button
							className="mt-3"
							variant="primary"
							type="submit"
							disabled={loading}>
							{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
							{Translate[lang]?.employee}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</Card>
	);
};

export default AddEmployee;
